import { DisplayConfigType } from 'formats/display/lib/config';
import { getOgAdContext, isWeb } from './environment-utils';

export function isSupplyMonitoringEventsEnabled(
  formatConfig: DisplayConfigType
) {
  if (!isWeb()) return false;

  if (getOgAdContext().enable_supply_monitoring_events) return true;

  return !formatConfig.isMraidCompliant;
}
